<div class="bank-card">
  <!-- ? Bank name -->
  <div class="name-container">
    <p class="name">بانک {{ bankAccountData.bankName }}</p>

    <ngx-badge
      size="md"
      mode="bold"
      [hasIcon]="true"
      type="text"
    >
      تایید شده
    </ngx-badge>
  </div>

  <!-- ? Sheba -->
  <div class="sheba">
    <span class="title"> شماره شبا: </span>
    <span class="value">
      {{ bankAccountData.shabaNumber }}
    </span>
  </div>
</div>
